import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { useState, useEffect } from "react";
import WebSocketConnection from "../utils/WebSocketConnection";

const Header = ({ children }) => {
	const [wsConnected, setWsConnected] = useState(
		WebSocketConnection.connected ? "true" : "error"
	);
	useEffect(() => {
		WebSocketConnection.setConnectionStatus = setWsConnected;
	}, []);

	return (
		<>
			<header>
				<Box>
					<AppBar
						position="static"
						sx={{ boxShadow: "none", backgroundColor: "#003F5E" }}
					>
						<Toolbar>
							<Box
								sx={{
									marginY: 2,
								}}
							>
								<Link to="/">
									<img
										src="/Club-Champion-logo-wt.svg"
										alt="logo"
										height={64}
									/>
								</Link>
							</Box>
						</Toolbar>
					</AppBar>
					{wsConnected !== "true" ? (
						<Alert severity="error">
							Connection to Trackman was lost. Please go back to the main page
							and reconnect. Your session data will be saved
						</Alert>
					) : null}
				</Box>
			</header>
			{children}
		</>
	);
};
export default Header;
